// extracted by mini-css-extract-plugin
export default {"text-caontainer-el":"style_text-caontainer-el__q76lv","ellipsis-text":"style_ellipsis-text__V3OOY"};